import { use, useEffect } from 'react';

import { FormAddElementEvent } from '../../../lib/flotiq-plugins/plugin-events/FormAddElementEvent';

import ElementFromPlugin from '../../../components/ElementFromPlugin/ElementFromPlugin';

import useMediaUpload from '../../../hooks/api/useMediaUpload';
import usePluginResults from '../../../hooks/usePluginResults';

import ContentObjectFormContext from '../../../contexts/ContentObjectFormContext';

import { useFormApi } from '../../useFormApi';

interface CustomFormElementProps {
  /**
   * Callback to set plugin renders count
   */
  setCount?: (count: number) => void;
}

const CustomFormElement = ({ setCount }: CustomFormElementProps) => {
  const { contentType, initialData, formUniqueKey } = use(
    ContentObjectFormContext,
  );
  const { onUpload: onMediaUpload } = useMediaUpload();

  const formProps = useFormApi();

  /**
   * @emits FlotiqPlugins."flotiq.form::add"
   */
  const pluginRenders = usePluginResults(
    'flotiq.form::add',
    FormAddElementEvent,
    {
      contentType,
      form: formProps,
      onMediaUpload,
      initialData,
      formUniqueKey,
    },
  );

  useEffect(() => {
    setCount?.(pluginRenders?.length);
  }, [pluginRenders?.length, setCount]);

  return pluginRenders?.length ? (
    <ElementFromPlugin results={pluginRenders} />
  ) : null;
};

export default CustomFormElement;
